import React, { useState, useEffect } from 'react'
import { Typography, Paper, Box } from '@mui/material';
import moment from 'moment'

const Comment = ( {articleId} ) => {
  
    let [ comments, setComments ] = useState([])
  
    useEffect(() => {
      getComments()
    },[])

    const backend = 'https://oureclecticsociety.org/core'
  
    let getComments = async () => {
      let response = await fetch(`${backend}/article-comments/${articleId}`)
      let data = await response.json()
      setComments(data)
    }

    return (
        <Box className="scroll">
            <Typography align="right" variant='h4'>Comments</Typography>
            {comments.map( (comment, index) => 
                (
                    <Paper key={index} elevation={5} sx={{ mb: 2, p: 1 }}>
                        <Typography variant='h6'>{comment.comment}</Typography>
                        <Typography align="right"> { moment(comment.created).format('DD/MM/YYYY HH:mm') }</Typography>
                    </Paper>
                )
            )}
        </Box>
    )
}

export default Comment
